import React from 'react';

import { CapabilityName } from '~configs/capabilities';
import { useCan } from '~hooks/user/useCan';

type Props = {
  /** Capability name from the central registry (`~configs/capabilities`). */
  capability: CapabilityName;
  /** Rendered when the capability is denied. Defaults to nothing. */
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Declarative capability gate for both in-page elements (filters, buttons,
 * sections) and route-level gates — the only gating primitive in this app
 * today (no `RolesRestrict`-style role-list component exists here).
 *
 * `<Can capability="pinning.workflow.access"><HomePage /></Can>`
 */
export const Can = ({ capability, fallback = null, children }: Props) => {
  const allowed = useCan(capability);

  return <>{allowed ? children : fallback}</>;
};
